<script lang="ts">
    import type { SubPoint } from "../../../../../types/global"
    import SubField from "./subField.svelte"
    import { apiBaseURL } from "../../../config"

    export let subPoint: SubPoint
</script>

<div class="text-container">
    <div>{@html subPoint?.content}</div>

    <div class="add">
        {#if subPoint?.linkref}
            <a href="{subPoint?.linkref}" target="_blank">
                <img src="/media/open-in-new.svg" alt="link" /> Link
            </a>
        {/if}
        {#if subPoint?.downloadFile}
            <a href="{`${apiBaseURL}subpoint/${subPoint.id}/${subPoint.downloadFile?.src}`}" download="h+h-download">
                <img src="/media/file-download.svg" alt="file" /> Download
            </a>
        {/if}
    </div>
</div>

<style lang="less">
    @import "../../assets/css/variables.less";
    .text-container {
        width: 100%;
        position: relative;

        @media @mobile {
            padding: 40px 0px 12px 10px;
        }
        @media @tablet {
            padding: 40px 0px 20px 40px;
        }

        .add {
            position: absolute;
            top: 10px;
            right: 10px;
            display: flex;
            align-items: center;
            gap: 20px;
            a {
                display: flex;
                align-items: center;
            }
        }
    }
</style>
